/* eslint-disable react/no-unescaped-entities */
/* eslint-disable react/jsx-key */
/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */
import React,{useEffect,useState,useCallback,useContext} from 'react'
import moment from 'moment'
import ReactModal from 'react-modal';
import { useNavigate } from 'react-router-dom';
import HeaderContext from '../../../Components/Context/HeaderContext';
import { CartPayload } from '../../../redux/helper/CartPayloadGenerator';
import { distributorService } from '../../../service/distributor.service';
import ClearCart from './ClearCart';

export default function AllOfferProgress({ViewBulkOffer,cartProducts,cartList,selectedCriteria,ViewData,specialCartList,
    prodItem,
    offerData,
    overAllCriteria,
    Subscription,
}) {
    const navigate = useNavigate();
    const {
        SetSuccessMessage,
        setcolorValue,
        SetErrorMessage,
    } = useContext(HeaderContext);
    const {items} = ViewBulkOffer;
    const [removePopup, setremovePopup] = useState('');
    const [removeLoader, setremoveLoader] = useState(false);
    useEffect(() => {
        handlequantity()

    }, [specialCartList])
    
    const handleSuccessMessage = (name)=>{     
        SetSuccessMessage(name);     
        setTimeout(() => {
            SetSuccessMessage('');
            setModalOpen('');
            setcolorValue(false);
            if(diff){
                setModalOpen('popup')
            }
        },1000)
    }

    const handleTotalValue =useCallback(
        (key)=>{
            const List = Object.values(specialCartList)||[];
            let totalCount = 0;
            List.map((item)=>{
                if(key==='quantity'){
                    totalCount+=Number(item.quantity)
                }else{
                    totalCount+=Number(item.LIST_PRICE) *Number(item.quantity)
    
                }
            })
            return totalCount;
        },
        [specialCartList],
    )
    const handleCalculation =useCallback(
        (key)=>{
            const List = prodItem;
            let totalCount = 0;
            Object.keys(List).length>0 && Object.keys(List).map((item)=>{
                totalCount+=parseFloat(List[item][key]||0)
            })
            return totalCount;
        },
        [specialCartList],
    )

    
 
    
    // const CriteriaMeetCheck=(item,i)=>{
    //     let status=false
    //     if(offerData.items){
    //         if(item.OFFER_PARAMETER==='quantity'){
    //             const count =GetCartCount(i,'total')
    //             status=count >=Number(item.MIN_QUANTITY) && count <=Number(item.MAX_QUANTITY)
    //         }else{
    //             const valCount=Object.keys(offerData?.items)?.length>0?offerData?.items[item.id]?.orderValue:0
    //             status=valCount>=Number(item.MIN_VALUE) && valCount <=Number(item.MAX_VALUE)
    //         }
    //     }
    //     return status
    // }
    const handleAddBulkProducts = async(key)=>{
        let exist =false;
        if(key===undefined){
            const cartItems = await distributorService.CartItems();
            if(!cartItems.error && cartItems.data.data.cart_items.length>0){
                exist=true;
                setremovePopup('active')

            }else{
                exist=false
            }
        }
        const payload =Object.values(specialCartList);
        if(exist=== false){
            distributorService.BulkAddFromOffer(payload).then((res)=>{
                if(!res.error && res.data.success_status){
                    handleSuccessMessage(res.data.message)
                    localStorage.setItem('FromOffer','1')
                    navigate('/cart');
                }
            })
            offerData?.products
        }
      
    }
    const handleClearCart=async()=>{
        const cart = await distributorService.clearCart();
        if(!cart.error && cart.data.success_status){
            cartList();
            setremovePopup('');
            handleAddBulkProducts('key')

        }

    }
    const handlequantity = useCallback(
        ()=>{
            const copy = {};
            Object.keys(specialCartList).map((val)=>{
                if(copy[specialCartList[val].PRIMARY_UOM_CODE]){
                    copy[specialCartList[val].PRIMARY_UOM_CODE]+=parseFloat(specialCartList[val].quantity)
                }else{
                    copy[specialCartList[val].PRIMARY_UOM_CODE]=parseFloat(specialCartList[val].quantity)
                }
            })
            return copy    
        },
        [specialCartList],
    )
    const customStyles = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
        },
    };
    
    return (
        <div className="lg:min-w-[35%] min-w-full h-auto bg-[#E9EDF4] rounded-lg lg:ml-[18px] ml-0 mb-2.5 border-2 border-[#E9EDF4] lg:mt-14 mt-3 p-4 self-end">
            <ReactModal  style={customStyles}  isOpen={removePopup!==''}>
                <ClearCart
                    // RemoveFromCart={RemoveFromCart}
                    setremovePopup={setremovePopup}
                    handleClearCart={handleClearCart}
                    handleAddBulkProducts={handleAddBulkProducts}
                    loading={removeLoader}
                    setremoveLoader={setremoveLoader}/>
            </ReactModal>
            <p className="text-[#808285] text-sm font-bold">Progress</p>
            {overAllCriteria && Object.entries(overAllCriteria).map(([key,value])=>(
                <div className="px-1 mt-4">
                    <div className="flex justify-between items-center">
                        <div className="relative checkbox custom-checkbox custom-checkbox2 custom-checkbox3 custom-checkbox4 flex items-center">
                            <input type="checkbox" id="checkbox-1" checked={value.quantity >= value.MIN_QUANTITY}/>
                            <label htmlFor="checkbox-1" className="text-sm font-bold text-[#555259] pl-2 cursor-pointer">Criteria {key} <span className="text-[#ED1C24]">*</span></label>
                        </div>
                        <p className="text-xs font-normal text-[#206C00]">{`${value.quantity.toLocaleString("en-IN")}/${value.MIN_QUANTITY.toLocaleString("en-IN")}`}</p>
                    </div>
                </div>))
            }
            <div className="flex justify-between border-t border-[#707070] mt-3 pt-3">
                <p className="font-normal text-sm text-[#000000]">Total Order Qty</p>
                <p className="text-[#000000] font-semibold sm:text-xs7 text-base">{Object.values(overAllCriteria).reduce((accumulator, currentValue) => accumulator + Number(currentValue.quantity),0).toLocaleString("en-IN")}</p>
            </div>
            <div className="flex justify-between sm:mt-3 mt-2.5">
                <p className="font-normal text-sm text-[#000000]">Total Net Amount</p>
                <p className="text-[#000000] font-semibold sm:text-xs7 text-base">₹{Object.values(overAllCriteria).reduce((accumulator, currentValue) => accumulator + Number(currentValue.total),0).toLocaleString("en-IN")}</p>
            </div>
            <button 
                onClick={()=>handleAddBulkProducts()}
                type="button"
                disabled={parseFloat(handleTotalValue('quantity')) === 0 || Subscription.fulfillment_percentage >=100 || (moment(moment(moment.now()).format("DD/MM/YYYY"))>moment(moment(new Date(ViewBulkOffer.items.end_date)).format("DD/MM/YYYY")))}
                className={`w-full ${ parseFloat(handleTotalValue('quantity')) === 0?'bg-[#A5A5A5]':'bg-[#555259]'} rounded-[8px] text-[#FFFFFF] text-sm font-semibold py-3 mt-2`}
                data-bs-toggle="modal"
                data-bs-target="#addtocart">
                Add all products to Cart
            </button>
            {Subscription.fulfillment_percentage >=100 && <p className='text-[#ED1C24]'>You can't place order for Fulfilled subscription, Please create new subscription</p>}
            {(moment(moment(moment.now()).format("DD/MM/YYYY"))>moment(moment(new Date(ViewBulkOffer.items.end_date)).format("DD/MM/YYYY"))) && <p className='text-[#ED1C24]'>This Offer has been Expired</p> }
        </div>
    )
}
